import React, { useState } from "react";
import {
    ReferenceInput as RaReferenceInput,
    useRecordContext,
    type RaRecord,
    type ReferenceInputProps as RaReferenceInputProps,
} from "react-admin";

// @ts-expect-error
export interface ReferenceInputProps<
    T extends RaRecord = RaRecord,
    U extends RaRecord = RaRecord,
> extends RaReferenceInputProps {
    source: keyof T;
    reference: string;
    filter?: Partial<U>;
    sort?: { field: keyof U; order: "ASC" | "DESC" };
    map?: (record: T) => U;
}

export function ReferenceInput<
    T extends RaRecord = RaRecord,
    U extends RaRecord = RaRecord,
>({
    source,
    map,
    children,
    queryOptions,
    ...rest
}: ReferenceInputProps<T, U>): JSX.Element {
    const [focused, setFocused] = useState(false);
    const r = useRecordContext<T>(rest.record);
    let extracted: U | undefined = undefined;
    if(map && r) {
        extracted = map(r);
    }
    return (
        <RaReferenceInput
            source={source}
            queryOptions={{ staleTime: 0, initialData: extracted?.id ? [extracted] : [], ...queryOptions }}
            enableGetChoices={_ => focused}
            {...(rest as any)}
        >
            {
                React.Children.map(children, (child: any) => React.cloneElement(child, { 
                    onFocus: () => setFocused(true) 
                }))
            }
        </RaReferenceInput>
    );
}